import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoaderEnabled } from '../../services/loader.service';
import { SubscriptionFilter, SubscriptionModelResponse, SubscriptionsFilterCounter } from './subscriptions.types';

@Injectable({
  providedIn: 'root',
})

export class SubscriptionsApiService {
  constructor(private httpClient: HttpClient) {}

  @LoaderEnabled()
  fetchFilterCounters(): Observable<SubscriptionsFilterCounter> {
    return this.httpClient.get<SubscriptionsFilterCounter>('/api/kkms/subscriptions/counts');
  }

  fetchSubscriptions(subscriptionFilter: SubscriptionFilter = {}): Observable<SubscriptionModelResponse> {
    return this.httpClient.post<SubscriptionModelResponse>('/api/kkms/subscriptions', subscriptionFilter);
  }
}
